import React from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import {
  AlertCircle as AlertCircleIcon,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  ChevronDown as ChevronDownIcon,
} from 'react-feather'

import constants from 'constants/index'
import useStyles from './styles'

// Parecer do projeto revisado: status na primeira linha e o parecer com rolagem
// própria, para um parecer longo não esticar a tela. As ações do rodapé variam
// por audiência, então vêm por prop.
const PrivacyByDesignReviewPanel = ({ privacyByDesign, actions }) => {
  const classes = useStyles()

  const {
    APPROVED_STATUS_LABEL,
    REVIEWED_STATUSES,
    RISK_ASSUMED_STATUS_LABEL,
  } = constants.privacyByDesign

  const isApproved = privacyByDesign?.status === APPROVED_STATUS_LABEL
  const isRiskAssumed = privacyByDesign?.status === RISK_ASSUMED_STATUS_LABEL
  const isDisapproved = !isApproved && !isRiskAssumed

  const reviewStatusLabel = isApproved
    ? 'Aprovado'
    : isRiskAssumed
    ? 'com Risco Assumido'
    : 'Reprovado'

  const reviewerOpinion = privacyByDesign?.latestReviewerOpinion?.content
  const riskAssumedJustify =
    privacyByDesign?.auditEntities?.riskAssumedJustify?.[0]?.content

  if (!REVIEWED_STATUSES.includes(privacyByDesign?.status)) return null

  return (
    <Box pb={2}>
      <Accordion
        variant="outlined"
        defaultExpanded={!!reviewerOpinion || !!riskAssumedJustify}
        className={clsx(classes.reviewAccordion, {
          [classes.reviewAccordionApproved]: isApproved,
          [classes.reviewAccordionRiskAssumed]: isRiskAssumed,
          [classes.reviewAccordionDisapproved]: isDisapproved,
        })}
      >
        <AccordionSummary expandIcon={<ChevronDownIcon size={18} />}>
          <Box className={classes.reviewSummary}>
            {isApproved && (
              <CheckCircleIcon size={20} className={classes.approvedIcon} />
            )}
            {isRiskAssumed && (
              <AlertCircleIcon size={20} className={classes.riskAssumedIcon} />
            )}
            {isDisapproved && (
              <AlertTriangleIcon
                size={20}
                className={classes.disapprovedIcon}
              />
            )}
            <Typography variant="body1">
              <strong>Projeto {reviewStatusLabel}</strong>
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails className={classes.reviewDetails}>
          {isRiskAssumed && (
            <Box>
              <Typography variant="subtitle2" gutterBottom>
                Justificativa do Risco Assumido
              </Typography>
              <Box className={classes.reviewerOpinionBox}>
                <Typography
                  variant="body2"
                  className={classes.reviewerOpinionText}
                >
                  {riskAssumedJustify || 'Sem justificativa registrada.'}
                </Typography>
              </Box>
            </Box>
          )}
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Parecer do Revisor
            </Typography>
            <Box className={classes.reviewerOpinionBox}>
              <Typography
                variant="body2"
                className={classes.reviewerOpinionText}
              >
                {reviewerOpinion || 'Sem parecer do revisor.'}
              </Typography>
            </Box>
          </Box>
          {!!actions && <Box className={classes.reviewActions}>{actions}</Box>}
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default PrivacyByDesignReviewPanel
